var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseButton',{staticClass:"bookmark-button",class:{ 'bookmark-button--active': _vm.isBookmarked },attrs:{"size":"auto"},nativeOn:{"click":function($event){return _vm.toggleBookmark()}}},[_c('fa-icon',{attrs:{"icon":"fa-light fa-bookmark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }